import {Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress} from "@mui/material";
import React, {useState} from "react";

const ImportModal = (props)  => {
    const {open, title, handleClose, bulkImportResult, bulkImportResultError, mutating, bulkImportRecords} = props;
    const [importing, setImporting] = useState(false);
    const [importFile, setImportFile] = useState(null);
    const [importError, setImportError] = useState('');
    const onChooseFile = (e) => {
        const file = e.target.files && e.target.files[0] ? e.target.files[0] : null;
        setImportFile(file);
        setImportError('');
    };

    const importRecords = async () => {
        if (!importFile) {
            setImportError('Please choose a .csv file');
            return;
        }

        if (!importFile.name.toLowerCase().endsWith('.csv')) {
            setImportError('Only .csv files are supported');
            return;
        }

        setImporting(true);
        await bulkImportRecords(importFile);
        closeImport();
    };

    const closeImport = () => {
        if (importing) return;
        setImportError('');
        setImportFile(null);
        setImporting(false);
        handleClose();
    }

    return (
        <Dialog open={open} onClose={closeImport} maxWidth="sm" fullWidth>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent dividers>
                <p style={{marginTop: 0}}>
                    Upload a CSV with headers that include at least:
                </p>
                <input
                    type="file"
                    name="file"
                    accept=".csv"
                    onChange={onChooseFile}
                    disabled={importing}
                    style={{margin: '8px 0'}}
                />
                {importError && <Alert severity="error" sx={{mt: 1}}>{importError}</Alert>}
                {bulkImportResultError &&
                    <Alert severity="error" sx={{mt: 1}}>{bulkImportResultError?.message}</Alert>}
                {importing && <LinearProgress sx={{mt: 2}}/>}
                {!mutating && bulkImportResult && (
                    <div style={{marginTop: 12}}>
                        {Array.isArray(bulkImportResult.errors) && bulkImportResult.errors.length > 0 && (
                            <div style={{
                                maxHeight: 180,
                                overflow: 'auto',
                                marginTop: 8,
                                fontFamily: 'monospace',
                                fontSize: 12
                            }}>
                                {bulkImportResult.errors.map((e, i) => (
                                    <div key={i}>
                                        Row {e.row}: {e.reason}{e.isbn ? ` (ISBN: ${e.isbn})` : ''}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={closeImport} disabled={importing}>Close</Button>
                <Button color="primary" variant="contained" onClick={importRecords}
                        disabled={importing || !importFile}>
                    {importing ? 'Uploading…' : 'Import'}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ImportModal;